// Cell.tsx
import React from "react";

// Utility function for formatting dates; adjust as needed
const formatDate = (value: string): string => {
  const date = new Date(value);
  return date.toLocaleString(); // Format based on user's locale
};

interface CellProps {
  value: any;
  fieldType: string;
}

const Cell: React.FC<CellProps> = ({ value, fieldType }) => {
  let displayValue = value;

  // If the field is a DateTime and has a valid value, format it
  if (fieldType === "DateTime" && value) {
    displayValue = formatDate(value);
  }

  // If the value is null or undefined, show a dash
  if (value === undefined || value === null) {
    displayValue = "-";
  }

  return <span>{displayValue}</span>;
};

export default Cell;
